module.exports = __webpack_public_path__ + "static/img/4.5b7628a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/8/4/eng/4.png
// module id = M0N+
// module chunks = 0